/**
 * Maps through all the children of the main node and maps a deleted array
 * @param {*} treeId the id of the tree 
 * @param {*} relationships the relationships to be mapped
 */
export function treeDelete(treeId, relationships) {
    return new Promise((resolve) => {
        let deleteArray = [];
        let relationshipsArray = Object.entries(relationships);
        parentFinder(treeId, relationshipsArray).then((parent => {
            //if theres no parent add the one entry to teh array 
            if (parent === null) {
                relationshipsArray.forEach((parentData => {
                    parentData[1].children.forEach((children => {
                        if (children === treeId) {
                            let obj = {
                                id: treeId,
                                relationshipId: parentData[1].id
                            };
                            deleteArray.push(obj);
                            // console.log(deleteArray);
                            return resolve(deleteArray);
                        }
                    }));
                }));
            } else {
                let obj = {
                    id: treeId,
                    relationshipId: parent.id
                };
                deleteArray.push(obj);
                //does it have children? find them
                if (parent.children) {
                    findChildren(parent);
                }
            }
        }));
        /**
         * recursivie function that goes through the parents children
         * @param {*} parent the parent obj
         */
        let findChildren = function (parent) {
            if (parent.children) {
                parent.children.forEach((child => {
                    let obj = {
                        id: child,
                        relationshipId: parent.id
                    };
                    deleteArray.push(obj);
                    parentFinder(child, relationshipsArray).then((parent) => {
                        if (parent === null) {
                            return resolve(deleteArray);
                        }
                        findChildren(parent);
                    });
                }));
            } else {
                return resolve(deleteArray);
            }
        };
        return resolve(deleteArray);
    });
}

/**
 * helper class ti help find the parent
 * @param {*} treeId the id of the tree
 * @param {*} relationship relationships
 */
function parentFinder(treeId, relationship) {
    return new Promise(resolve => {
        relationship.forEach((parent => {
            if (parent[1].parent === treeId) {
                return resolve(parent[1]);
            }
        }));
        return resolve(null);
    });
}


// WEBPACK FOOTER //
// ./src/services/relationshipBuilder.js